import React, { Fragment, Component } from "react";
import { inject, observer } from "mobx-react";
import { ContainerQuery } from "react-container-query";
import DocumentTitle from "react-document-title";
import classNames from "classnames";
import {
	Card,
	Button,
	Form,
	Select,
	Tabs,
	Row,
	Divider,
	Icon,
	Radio,
	Spin,
	Menu,
	Dropdown,	
	Popover,
	Layout,
	message,
	Modal
} from "antd";
import SiderMenu from "components/SiderMenu";
import GlobalFooter from "components/GlobalFooter";
import logo from "assets/logo.svg";
import { getMenuData } from "common/menu";
import AccountTab from "./components/AccountTab";
import AddEditScheduleDialog from "components/AddEditScheduleDialog";
import VerificationInfoTab from "./components/VerificationInfoTab";
import SitesTab from "./components/SitesTab";
import SiteList from "components/SiteList";
// import "antd/dist/antd.css";
import styles from "./index.module.less";
import omit from "lodash/omit";
import BasicLayout from "layouts/BasicLayout";
import co from "co";
import { ModuleMap, ModuleValue } from "common/modules";
import PageHeaderLayout from "../../layouts/PageHeaderLayout";
import { locationPrefix } from "common/general";

const { Content, Header, Footer } = Layout;

const query = {
	"screen-xs": {
		maxWidth: 575
	},
	"screen-sm": {
		minWidth: 576,
		maxWidth: 767
	},
	"screen-md": {
		minWidth: 768,
		maxWidth: 991
	},
	"screen-lg": {
		minWidth: 992,
		maxWidth: 1199
	},
	"screen-xl": {
		minWidth: 1200
	}
};

const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

const tailFormItemLayout = {
	wrapperCol: {
		xs: {
			span: 24,
			offset: 0
		},
		sm: {
			span: 20,
			offset: 4
		}
	}
};

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 4 }
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 20 }
	}
};

function getTextFilter() {
	function TextFilter() {}

	TextFilter.prototype.init = function(params) {
		this.valueGetter = params.valueGetter;
		this.filterText = null;
		this.setupGui(params);
	};

	// not called by ag-Grid, just for us to help setup
	TextFilter.prototype.setupGui = function(params) {
		this.gui = document.createElement("div");
		this.gui.innerHTML =
			'<div style="padding: 4px;">' +
			'<div style="font-weight: bold;">Search for sites</div>' +
			'<div><input style="margin: 4px 0px 4px 0px;" type="text" id="filterText" placeholder="Site url..."/></div>' +
			'<div style="margin-top: 5px; width: 200px;">Enter the sites that you want to search for</div>' +
			"</div>";

		this.eFilterText = this.gui.querySelector("#filterText");
		this.eFilterText.addEventListener("changed", listener);
		this.eFilterText.addEventListener("paste", listener);
		this.eFilterText.addEventListener("input", listener);
		// IE doesn't fire changed for special keys (eg delete, backspace), so need to
		// listen for this further ones
		this.eFilterText.addEventListener("keydown", listener);
		this.eFilterText.addEventListener("keyup", listener);
		this.filterChangedCallback = params.filterChangedCallback;

		var that = this;

		function listener(event) {
			that.filterText = event.target.value;
			params.filterChangedCallback();
		}
	};

	TextFilter.prototype.getGui = function() {
		return this.gui;
	};

	TextFilter.prototype.doesFilterPass = function(params) {
		// make sure each word passes separately, ie search for firstname, lastname
		var passed = true;
		var valueGetter = this.valueGetter;
		var value = valueGetter(params);
		if (
			value
				.toString()
				.toLowerCase()
				.indexOf(this.filterText.toLowerCase()) < 0
		) {
			passed = false;
		}
		if (passed && this.filterText.toLowerCase() == "wordpress.com") {
			// console.log(params);
		}
		return passed;
	};

	TextFilter.prototype.isFilterActive = function() {
		var isActive =
			this.filterText !== null &&
			this.filterText !== undefined &&
			this.filterText !== "";
		return isActive;
	};

	TextFilter.prototype.getApi = function() {
		var that = this;
		return {
			getModel: function() {
				var model = { value: that.filterText.value };
				return model;
			},
			setModel: function(model) {
				that.eFilterText.value = model.value;
			}
		};
	};

	TextFilter.prototype.getModelAsString = function(model) {
		return model ? model : "";
	};

	TextFilter.prototype.getModel = function() {
		return this.filterText;
	};
	// lazy, the example doesn't use setModel()
	TextFilter.prototype.setModel = function(params) {
		if (!params) {
			this.filterText = "";
			this.eFilterText.value = "";
			this.filterChangedCallback();
		}
	};

	return TextFilter;
}

var doFollowRenderer = function(params) {
	if (params.node.group == true) {
		return null;
	}
	if (params.value == true) {
		return "<span>Yes</span>";
	} else {
		return "<span>No</span>";
	}
};

var siteStatusRenderer = function(params) {
	if (params.value == "SUCCESS") {
		return '<div class="ant-tag ant-tag-has-color" style="background-color: rgb(17, 119, 51);">Success</div>';
	} else if (params.value == "FAILED") {
		return '<div data-show="true" class="ant-tag ant-tag-gray">Failed</div>';
	} else if (params.value == "NONE") {
		return "";
	} else if (params.value == "RUNNING") {
		return '<div class="ant-tag ant-tag-has-color" style="background-color: rgb(16, 142, 233);">Running</div>';
	} else {
		return "<span></span>";
	}
};

var moduleFormatter = function(params) {
	return ModuleMap[params.value];
};

function strcmp(a, b) {
	return a < b ? -1 : a > b ? 1 : 0;
}

@inject("rootStore")
@observer
class MainTabs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeKey: "Account"
		};
	}

	setActiveKey = activeKey => {
		this.setState({ activeKey });
	};

	handleTabChange = activeKey => {
		this.setState({ activeKey });
	};

	render() {
		return (
			<Tabs
				// type="card"
				activeKey={this.state.activeKey}
				ref={tabs => (this.tabs = tabs)}
				onChange={this.handleTabChange}
				animated={false}
			>
				<TabPane tab="Account" key="Account" forceRender={true}>
					{this.props.accountTab}
				</TabPane>
				<TabPane tab="Email" key="Email" forceRender={true}>
					{this.props.verificationInfoTab}
				</TabPane>
				<TabPane tab="Sites" key="Sites" forceRender={true}>
					{this.props.siteListTab}
				</TabPane>
			</Tabs>
		);
	}
}

@inject("rootStore")
@observer
class Project extends Component {
	constructor(props) {
		super(props);
	}

	getProject = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		return acProjectStore.project;
	};

	onRowSelected(event) {
		// console.log(event);
	}

	loadSites(projectId) {
		this.props.dispatch({
			type: "AccountCreationProject/remoteLoadProject",
			payload: {
				projectId: projectId
			}
		});
		// console.log("loading sites");
	}

	downloadRankerXEmail = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;

		acProjectStore.downloadRankerXEmail();
	};

	saveSchedule = payload => {
		const {
			rootStore: { acProjectStore }
		} = this.props;

		acProjectStore.saveSchedule(payload);
	};

	deleteSchedule = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;

		acProjectStore.deleteSchedule();
	};

	resetSchedule = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;

		acProjectStore.resetSchedule();
	};

	downloadEmailFromEmailList = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		acProjectStore.downloadEmailFromEmailList();
	};

	handleScheduleMenuClick = ({ key }) => {
		if (key == "addEditSchedule") {
			this.showAddEditScheduleDialog();
			return;
		}
		if (key == "deleteSchedule") {
			this.deleteSchedule();
			return;
		}
		if (key == "resetSchedule") {
			this.resetSchedule();
			return;
		}
	};

	showAddEditScheduleDialog = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		let result = co(
			function*() {
				let response = yield this.accountTab.validateForm();
				if (response != null) {
					this.mainTabs.wrappedInstance.setActiveKey("Account");
					return;
				}
				response = yield this.verificationInfoTab.validateForm();
				if (response != null) {
					this.mainTabs.wrappedInstance.setActiveKey("Email");
					return;
				}
				
				let sites = this.sitesTab.getRowData();

				let selectedSiteCount = sites.reduce((count, site) => {
					if (site.checked) {
						count++;
					}
					return count;
				}, 0);

				if (selectedSiteCount > 0) {							
					acProjectStore.showAddEditScheduleDialog();
				} else {
					this.mainTabs.wrappedInstance.setActiveKey("Sites");
					message.error("Please fix all the errors below", 5);
				}						
			}.bind(this)
		);
	};
	startStopProject = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		const project = acProjectStore.project;
		if (
			["NEW", "COMPLETED", "STOPPED", "FAILED"].indexOf(project.status) != -1
		) {
			acProjectStore.startProject();
			return;
		}
		if (["STARTING", "RUNNING"].indexOf(project.status) != -1) {
			acProjectStore.stopProject();
			return;
		}
	};

	hideAddEditScheduleDialog = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		acProjectStore.hideAddEditScheduleDialog();
	};

	generateRandomInfo = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		acProjectStore.generateRandomInfo();
	};

	temporarilySaveProject = e => {
		if (this.props.editing) {
			let accountData = this.accountTab.getValues();
			let verificationInfo = this.verificationInfoTab.getValues();
			let project = {
				...accountData,
				emailAddress: verificationInfo.projectEmailAddress,
				verificationInfo: omit(verificationInfo, ["projectEmailAddress"])
			};
			this.props.dispatch({
				type: "AccountCreationProject/temporarilySaveProject",
				payload: project
			});
		}
	};
	toggleEdit = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		if (!acProjectStore.ui.editing) {
			acProjectStore.startEditingProject();
		} else {
			co(
				function*() {
					let response = yield this.accountTab.validateForm();
					if (response != null) {
						this.mainTabs.wrappedInstance.setActiveKey("Account");
						return;
					}
					response = yield this.verificationInfoTab.validateForm();
					if (response != null) {
						this.mainTabs.wrappedInstance.setActiveKey("Email");
						return;
					}

					let sites = this.sitesTab.getRowData();

					let selectedSiteCount = sites.reduce((count, site) => {
						if (site.checked) {
							count++;
						}
						return count;
					}, 0);
	
					if (selectedSiteCount > 0) {							
						acProjectStore.saveProject(sites);
					} else {
						this.mainTabs.wrappedInstance.setActiveKey("Sites");
						message.error("Please fix all the errors below", 5);
					}					
				}.bind(this)
			);
		}
	};

	cancelEdit = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;

		if (acProjectStore.ui.editing) {
			acProjectStore.cancelEditingProject();
		}
	};
	startStopVerifyingMails = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		const project = acProjectStore.project;
		if (["STARTING_VERIFYING", "VERIFYING"].indexOf(project.status) != -1) {
			acProjectStore.stopVerifyingMails();
			return;
		}
		if (
			["NEW", "COMPLETED", "STOPPED", "SCHEDULED", "FAILED"].indexOf(
				project.status
			) != -1 &&
			acProjectStore.ui.editing == false
		) {
			acProjectStore.startVerifyingMails();
			return;
		}
	};
	testEmail = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		acProjectStore.testEmail();
	};

	createColumnDefs(props) {
		return [
			{
				headerName: "Module",
				field: "id.module",
				valueFormatter: moduleFormatter,
				editable: false,
				hide: false,
				rowGroupIndex: 0
			},
			{
				headerName: "Platform",
				field: "platform",
				editable: false,
				hide: false,
				rowGroupIndex: 1
			},
			{
				field: "id",
				headerName: "ID",
				editable: false,
				hide: true
			},
			// {
			// 	headerName: "Site",
			// 	field: "id.siteId",
			// 	width: 267,
			// 	editable: false,
			// 	filter: "agTextColumnFilter"
			// 	// filter: getTextFilter()
			// 	// checkboxSelection: function(params) {
			// 	// 	return (
			// 	// 		params.columnApi.getRowGroupColumns().length === 0
			// 	// 	);
			// 	// },
			// },
			{
				headerName: "Status",
				field: "status",
				width: 150,
				editable: false,
				cellRenderer: siteStatusRenderer,
				filter: "agSetColumnFilter",
				filterParams: {
					values: ["NONE", "SUCCESS", "FAILED", "RUNNING"]
				},
				// checkboxSelection: function(params) {
				// 	return (
				// 		params.columnApi.getRowGroupColumns().length === 0
				// 	);
				// },
				cellClass: function() {
					return "alphabet";
				}
			},
			// {
			// 	headerName: "Game Name",
			// 	field: "game.name",
			// 	width: 267,
			// 	editable: false,
			// 	filter: "agSetColumnFilter",
			// 	tooltipField: "gameName",
			// 	// checkboxSelection: function(params) {
			// 	// 	return (
			// 	// 		params.columnApi.getRowGroupColumns().length === 0
			// 	// 	);
			// 	// },
			// 	cellClass: function() {
			// 		return "alphabet";
			// 	}
			// },
			{
				headerName: "DA",
				field: "pr",
				width: 100,
				editable: false,
				floatCell: true,
				filter: "agNumberColumnFilter",
				filterParams: {
					filterOptions: ["greaterThanOrEqual"],
					cellHeight: 20,
					newRowsAction: "keep"
				}
			},
			{
				headerName: "Dofollow",
				field: "dofollow",
				width: 150,
				editable: false,
				cellRenderer: doFollowRenderer,
				filter: "agSetColumnFilter"
			},
			{
				headerName: "Progress",
				field: "waitInfo",
				width: 250,
				editable: false,
				suppressFilter: true,
				suppressMenu: true,
				suppressSorting: true
			}
		];
	}

	getRowNodeId = (data) => {
		return data.id.module + "_" + data.siteId;
	}

	showLastError = () => {
		const {
			rootStore: { acProjectStore }
		} = this.props;		
		let lastError = acProjectStore.project.lastError;		
		if (lastError) {
			var errorObj = JSON.parse(lastError);
			let errorArr = [];
			for (let i = 0; i < errorObj.length; i++) {
				errorArr.push(errorObj[i]);
				errorArr.push(<br/>);
			}
			Modal.error({
				title: "Error",
				content: errorArr,
			})
		}		
	}
	render() {
		const {
			rootStore: { acProjectStore }
		} = this.props;
		if (acProjectStore.ui.loadingProject == true) {
			return <div />;
		}
		let accountTab = (
			<AccountTab
				ref={accountTab => {
					if (accountTab != null) {
						this.accountTab = accountTab.wrappedInstance;
					} else {
						this.accountTab = null;
					}
				}}
			/>
		);

		let verificationInfoTab = (
			<VerificationInfoTab
				ref={verificationInfoTab => {
					if (verificationInfoTab != null) {
						this.verificationInfoTab = verificationInfoTab.wrappedInstance;
					} else {
						this.verificationInfoTab = null;
					}
				}}
			/>
		);

		const siteListTab = (
			<SitesTab
				ref={sitesTab => {
					if (sitesTab != null) {
						this.sitesTab = sitesTab.wrappedInstance;
					} else {
						this.sitesTab = null;
					}
				}}
			/>
		);

		let spinning =
			acProjectStore.ui.loadingProject == true ||
			acProjectStore.ui.savingProject == true ||
			acProjectStore.ui.deletingSchedule == true ||
			acProjectStore.ui.resetingSchedule == true;

		let addEditScheduleDialog = (
			<AddEditScheduleDialog
				ui={acProjectStore.ui}
				project={acProjectStore.project}
				siblings={acProjectStore.siblings}
				hideDialog={this.hideAddEditScheduleDialog}
				saveSchedule={this.saveSchedule}
				deleteSchedule={this.deleteSchedule}
				resetSchedule={this.resetSchedule}
			/>
		);

		const scheduleMenu = (
			<Menu onClick={this.handleScheduleMenuClick}>
				<Menu.Item key="addEditSchedule">
					{acProjectStore.project.schedule ? "Edit Schedule" : "Add Schedule"}
				</Menu.Item>
				{acProjectStore.project.schedule ? (
					<Menu.Item key="deleteSchedule">Delete Schedule</Menu.Item>
				) : (
					<Fragment />
				)}
				{acProjectStore.project.schedule ? (
					<Menu.Item key="resetSchedule">Reset Schedule</Menu.Item>
				) : (
					<Fragment />
				)}
			</Menu>
		);

		let disableEditingProject =
			[
				"STARTING_VERIFYING",
				"VERIFYING",
				"STOPPING_VERIFYING",
				"STARTING",
				"RUNNING",
				"STOPPING"
			].indexOf(acProjectStore.project.status) != -1;

		let startStopButtonText =
			["RUNNING"].indexOf(acProjectStore.project.status) != -1
				? "Stop"
				: "Start";

		let disableStartStopButton =
			acProjectStore.ui.editing == true
				? true
				: ["STARTING_VERIFYING", "VERIFYING", "STOPPING_VERIFYING"].indexOf(
						acProjectStore.project.status
				  ) != -1
					? true
					: false;

		let verifyMailButtonText =
			["STARTING_VERIFYING", "VERIFYING", "STOPPING_VERIFYING"].indexOf(
				acProjectStore.project.status
			) != -1
				? "Stop verifying"
				: "Verify mail";
		let disableVerifyMailButton =
			["STARTING", "RUNNING", "STOPPING"].indexOf(
				acProjectStore.project.status
			) != -1 || acProjectStore.ui.editing
				? true
				: false;

		let startButton = (
			<Button
				type="primary"
				disabled={disableStartStopButton}
				onClick={this.startStopProject}
				loading={
					acProjectStore.ui.startingProject || acProjectStore.ui.stoppingProject
				}
			>
				{startStopButtonText}
			</Button>
		);

		if (acProjectStore.project.status == "SCHEDULED") {
			startButton = (
				<Popover
					placement="bottom"
					content="The project is scheduled, you need to delete the schedule first"
					title="Cannot start the project"
					trigger="click"
				>
					<Button type="primary">{startStopButtonText}</Button>
				</Popover>
			);
		}

		const breadcrumbList = [
			{
				title: "Home",
				href: locationPrefix + "/"
			},
			{
				title: "Campaigns",
				href: locationPrefix + "/"
			},
			{
				title: "Campaign: " + acProjectStore.campaign.name,
				href: locationPrefix + "/campaign/" + acProjectStore.campaign.id
			},
			{
				title: "Project: " + acProjectStore.project.name
			}
		];

		// console.log("Rendering Account Creation Project");
		return (
			<PageHeaderLayout breadcrumbList={breadcrumbList}>
				{addEditScheduleDialog}
				{/* {addAccountProfileDialog} */}
				<Spin spinning={spinning} size="large">
					<Card bordered={false}>
						<Row>
							Project Status:
							<span className={styles.status}>
								{acProjectStore.project.status}
							</span>
							<span>{' '}Email Status:{' '}</span>							
							<span className={styles.status}>
								{acProjectStore.project.verificationInfo.status}
							</span>
						</Row>
						{acProjectStore.project.lastError ? (<Row>
							<Button type="danger" onClick={this.showLastError}>View Error</Button>
						</Row>): ""}
						<Row>
							<Form layout={"inline"}>
								<FormItem>
									<Button
										type="primary"
										onClick={this.toggleEdit}
										loading={acProjectStore.ui.savingProject}
										disabled={disableEditingProject}
									>
										{acProjectStore.ui.editing ? "Save" : "Edit"}
									</Button>
								</FormItem>
								<FormItem
									style={{
										display: acProjectStore.ui.editing ? "inline-block" : "none"
									}}
								>
									<Button type="primary" onClick={this.cancelEdit}>
										Cancel
									</Button>
								</FormItem>
								<FormItem>{startButton}</FormItem>
								<FormItem>
									<Button
										type="primary"
										disabled={disableVerifyMailButton}
										onClick={this.startStopVerifyingMails}
										loading={
											acProjectStore.ui.startingVerifyingMails ||
											acProjectStore.ui.stoppingVerifyingMails
										}
									>
										{verifyMailButtonText}
									</Button>
								</FormItem>
								<FormItem>
									<Dropdown overlay={scheduleMenu}>
										<Button type="primary">
											Schedule <Icon type="down" />
										</Button>
									</Dropdown>
								</FormItem>
							</Form>
						</Row>
					</Card>
					<Divider />
					<Card bordered={false}>
						{/* <div className={styles.cardcontainer}> */}
						<MainTabs
							{...this.props}
							accountTab={accountTab}
							verificationInfoTab={verificationInfoTab}
							siteListTab={siteListTab}
							ref={mainTabs => {
								this.mainTabs = mainTabs;
							}}
						/>
						{/* </div> */}
					</Card>
				</Spin>
			</PageHeaderLayout>
		);
	}
}

@inject("rootStore")
@observer
class ProjectPage extends Component {
	getPageTitle = () => {
		return "RankerX";
	};

	render() {		
		const {
			rootStore: { acProjectStore }
		} = this.props;

		return (
			<Fragment>{acProjectStore.ui.loadingProject ? "" : <Project />}</Fragment>
		);
	}
}

export default ProjectPage;
